import React, { Component } from 'react';
import API from '../api.js';
import Tools from '../tools';
import { Container, Row, Col, Form, Button, FormCheck } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setLoginData } from '../actions/actions';
import '../css/login.css';
import Enums from '../enums'

class ForgetPwd extends Component {

    constructor() {
        super();
        Tools.init();
        API.init(this);

        this.state = {
            ac: "",
            pw: "",
            pwChk: "",
            veriCode: "",
            isSendingVeri: false,
            isValid: false
        };
        this.onAcChange = this.onAcChange.bind(this);
        this.onPwChange = this.onPwChange.bind(this);
        this.onPwChkChange = this.onPwChkChange.bind(this);
        this.onVeriChange = this.onVeriChange.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.onForgetPassword = this.onForgetPassword.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onForgetPassword(e) {
        e.stopPropagation();
        e.preventDefault();
        // console.log(this.state);
        const { ac } = this.state;
        if (!ac || 0 == ac.length) {
            alert("請輸入帳號");
            return;
        }
        if (!Tools.validateEmail(ac)) {
            alert("請確認電子郵件");
            return;
        }
        // this.onEndEmailVerification = this.onEndEmailVerification.bind(this);
        this.setState({ isSendingVeri: true });
        API.ForgetPassword(ac)
            .then(data => {
                console.log(data);
                this.setState({ isSendingVeri: false });

                //401 {"msg":"Email格式錯誤","code":"24004"}
                //200 {"msg":"驗證信已寄出，請至您的電子郵件信箱確認驗證碼","code":"22020"}
                //200 {"msg":"此帳號已註冊","code":"23011"}

                if (!data || !data.code
                    || (22020 != data.code)
                ) {
                    if (data.msg) alert(data.msg);
                    else alert("請確認資料");
                } else {
                    if (data.msg) alert(data.msg);
                    else alert("驗證信已寄出，請至您的電子郵件信箱確認驗證碼");
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error))
    }

    onSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        this.setState({ isValid: true });

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            alert("請確認填寫內容")
            return;
        }
        if (false == this.state.agree) {
            alert("請同意相關條款")
            return;
        }

        // console.log(this.state);
        const header = {
            email: this.state.ac,
            email_verify_code: this.state.veriCode,
            new_password: this.state.pw,
            new_password_again: this.state.pwChk
        };

        API.ChangeForgetPassword(header)
            .then(data => {
                console.log(data, API.first_page);
                //{msg: "內文格式不符 org.json.JSONException: JSONObject["password_again"] not found.", code: "25000"}
                //{msg: "註冊成功:gloria_lin186@hotmail.com", code: "22000"}

                if (data && data.code) {
                    if (data.msg) alert(data.msg);
                    else alert("請確認資料");
                    if (22000 == data.code) {
                        setTimeout(() => {
                            this.props.history.push(API.first_page);
                        }, 100)
                    }
                } else {
                    alert("請確認資料");
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error))

        // API.Login(ac, pw
        // 	, function (data) {
        // 		// window.location.href = API.first_page;
        // 		console.log(API.first_page);
        // 		this.props.history.push(API.first_page);
        // 	}.bind(this), function (ac, tk) {
        // 		this.props.setLoginData(ac, tk)
        // 		// alert( $.i18n.get("login-failMsg") );
        // 	}.bind(this));
    }

    onAcChange(e) {
        this.setState({ ac: e.target.value });
    }
    onPwChange(e) {
        this.setState({ pw: e.target.value });
    }
    onPwChkChange(e) {
        this.setState({ pwChk: e.target.value });
    }
    onVeriChange(e) {
        this.setState({ veriCode: e.target.value.toUpperCase() });
    }


    renderForm() {
        const { ac, pw, pwChk, veriCode,
            currentCoAreaAry,
            isValid,
            isSendingVeri
        } = this.state;
        const { onAcChange, onPwChange, onPwChkChange, onSubmit,
            onForgetPassword,
            onVeriChange
        } = this;

        return (
            <>
                {/* <Col md={12}>
					<h1 className="text-border-white">EZChoice</h1>
				</Col> */}
                <Form validated={isValid}>
                    <Form.Group as={Row} controlId="formGroupSignup">
                        <Form.Label column xs={9}>透過帳號(電子郵件)傳送驗證碼</Form.Label>
                        <Col xs={{ span: 9 }}>
                            <Form.Control autoComplete="new-password" name="hidden" type="email" value={ac} onChange={onAcChange} placeholder="電子郵件" required />
                        </Col>
                        <Col xs={{ span: 3 }}>
                            <Button variant="link" className="w-100" onClick={onForgetPassword}>{isSendingVeri ? "發送中.." : "發送驗證碼"}</Button>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupSignup">
                        <Form.Label column xs={9}>輸入驗證碼</Form.Label>
                        <Col xs={9}>
                            <Form.Control autoComplete="new-password" name="hidden" type="text" value={veriCode} onChange={onVeriChange} placeholder="" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupPwd">
                        <Form.Label column xs={9}>請輸入新密碼</Form.Label>
                        <Col xs={9}>
                            <Form.Control autocomplete="new-password" name="hidden" type="password" value={pw} onChange={onPwChange} placeholder="密碼需使用8~20個英數混合字元" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupPwdCheck">
                        <Form.Label column xs={9}>確認新密碼</Form.Label>
                        <Col xs={9}>
                            <Form.Control autocomplete="new-password" name="hidden" type="password" value={pwChk} onChange={onPwChkChange} placeholder="密碼需使用8~20個英數混合字元" required />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formGroupBtns">
                        <Col xs={9} className="text-center">
                            <Button className="w-100" variant="primary" onClick={onSubmit}>確定</Button>
                        </Col>
                    </Form.Group>
                </Form>
            </>
        )
    }

    render() {
        const { renderForm } = this;

        return (
            <div id="main-content" className="mt-4">
                <Container className="h-100">
                    <Row className="justify-content-center h-100">
                        <Col className="my-auto col-11 offset-1 col-md-10 offset-md-2 col-lg-8">
                            <h4>重設密碼</h4>
                            {renderForm()}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ac: state.authReducer.ac,
    tk: state.authReducer.tk
})

const mapDispatchToProps = {
    setLoginData: setLoginData
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetPwd)
// export default Login;
